<template>
    <form-view class="vote-service-form-view" @submitsuccess="back">
        <template slot="field">
            <veui-field label="应用名称："
                name="appId"
                field="appId"
                :readonly="!!store.createForFixedAppId || isDetail"
                :disabled="isEdit"
                rules="required">
                <search-select
                    :options="store.appDatasource"
                    v-model="store.formData.appId"
                    placeholder="请选择"/>
                    <veui-button v-if="isCreate" @click="goToCreateApp" ui="link">新建应用</veui-button>
            </veui-field>
            <veui-field label="服务名称："
                name="name"
                field="name"
                :readonly="isDetail"
                :disabled="!isEditDraft && !isCreate"
                :rules="validator('required|name|maxLength:20')"
                tip="最多可输入20个字符">
                <veui-input
                    v-model="store.formData.name"
                    placeholder="数字、字母、汉字"/>
            </veui-field>
            <template v-if="isDetail">
                <veui-field label="authKey：">
                    <veui-span>{{ authKey }}</veui-span>
                </veui-field>
                <veui-field label="activityId：">
                    <veui-span>{{ activityId }}</veui-span>
                </veui-field>
            </template>
            <veui-field label="投票类型："
                name="rangeType"
                field="rangeType"
                rules="required">
                <veui-radio-group :items="store.voteTypeDatasource"
                    :readonly="isDetail"
                    v-model="store.formData.rangeType"/>
                <template v-if="store.formData.rangeType === 'multiple'">
                    <veui-select :options="rangeMinDatasource" :readonly="isDetail" v-model="store.formData.rangeMin"/>
                    <veui-select :options="rangeMaxDatasource" :readonly="isDetail" v-model="store.formData.rangeMax"/>
                </template>
            </veui-field>
            <veui-field label="投票选项："
                name="options"
                field="options"
                :readonly="isDetail"
                rules="required">
                <veui-textarea
                    v-model="store.formData.options"/>
            </veui-field>
        </template>
        <template slot="operation">
            <template v-if="isCreate || isEditDraft">
                <veui-button ui="primary" type="submit"
                    @click="store.formData.submitType='publish'">提交发布</veui-button>
                <veui-button class="primary-border-btn"
                    type="submit"
                    @click="store.formData.submitType='save'">保存为草稿</veui-button>
            </template>
            <veui-button v-else-if="isEdit"
                ui="primary"
                type="submit"
                @click="store.formData.submitType='publish'">修改完成</veui-button>
            <veui-button @click="back">{{ cancelText }}</veui-button>
        </template>
    </form-view>
</template>

<script>
import FormView from '@baidu/ve-ria/views/FormView';
import FormModel from './FormModel';
import createView from '@baidu/ve-ria/views/createView';
import {Steps, Field, Button, Input, Span, Select, RadioGroup, Textarea} from 'veui';
import SearchSelect from '@/common/components/SearchSelect';
import serviceMixin from '@/common/mixins/service';
import {range} from 'lodash';

export default createView(FormView, FormModel, {
    name: 'VoteServiceDetailView',
    components: {
        'veui-field': Field,
        'veui-input': Input,
        'veui-span': Span,
        'veui-button': Button,
        'veui-steps': Steps,
        'veui-select': Select,
        'veui-radio-group': RadioGroup,
        'veui-textarea': Textarea,
        SearchSelect
    },
    mixins: [serviceMixin],
    computed: {
        rangeMinDatasource() {
            return range(1, 11).map(i => ({label: i, value: i}));
        },
        rangeMaxDatasource() {
            let min = Number(this.store.formData.rangeMin || 1);
            return range(min, 11).map(i => ({label: i, value: i}));
        }
    }
});
</script>

<style lang="less">
.vote-service-form-view {
    .veui-input-input {
        width: 300px
    }
}
</style>
